import { comics } from '@/mocks/comics';
import { Link } from 'react-router-dom';

export default function TrendingRanking() {
  const trending = [...comics].sort((a, b) => (a.trending || 99) - (b.trending || 99)).slice(0, 10);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              热门排行
            </h3>
            <p className="text-sm text-foreground-500 mt-1">读者最爱的韩漫，热度排行TOP10</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {trending.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              onClick={() => window.scrollTo(0, 0)}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer group"
              data-product-shop
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${
                index < 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {index + 1}
              </div>
              <div className="w-14 h-20 rounded-md overflow-hidden flex-shrink-0 bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {comic.title}
                </h4>
                <p className="text-xs text-foreground-500 mt-1">
                  {comic.author} · {comic.category === 'love' ? '恋爱' : comic.category === 'action' ? '动作' : comic.category === 'fantasy' ? '奇幻' : comic.category === 'suspense' ? '悬疑' : comic.category === 'comedy' ? '搞笑' : comic.category === 'urban' ? '都市' : '古风'}
                </p>
                <div className="flex items-center gap-3 mt-2">
                  <span className="text-xs text-primary-600 font-medium">{comic.rating}分</span>
                  <span className="text-xs text-foreground-400">{comic.views}次阅读</span>
                </div>
              </div>
              <span className={`text-xs px-2 py-0.5 rounded-md flex-shrink-0 ${
                comic.status === '已完结'
                  ? 'bg-accent-100 text-accent-700'
                  : 'bg-secondary-100 text-secondary-700'
              }`}>
                {comic.status}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}